import { catchError } from "rxjs/operators";
import { getCookie, CookieTypes } from "./http/helpers/cookie-tools.js";
import { Fetcher } from "./http/http.js";
const isSpa = () => window.spa;
const preferredLanguageName = "preferredLanguage";
var ApiUrlTypes = /* @__PURE__ */ ((ApiUrlTypes2) => {
  ApiUrlTypes2["platform"] = "apiUrl";
  ApiUrlTypes2["site"] = "siteApi";
  ApiUrlTypes2["ws"] = "wsApi";
  return ApiUrlTypes2;
})(ApiUrlTypes || {});
var CustomerResponseTypes = /* @__PURE__ */ ((CustomerResponseTypes2) => {
  CustomerResponseTypes2["observable"] = "observable";
  CustomerResponseTypes2["promise"] = "promise";
  return CustomerResponseTypes2;
})(CustomerResponseTypes || {});
class ClientSwitcher {
  constructor(apiUrl, type, errorHandler, paymentiqTestApi, customApi, pgwApiUrl, appClient) {
    this.apiUrl = apiUrl;
    this.errorHandler = errorHandler;
    this.paymentiqTestApi = paymentiqTestApi;
    this.customApi = customApi;
    this.pgwApiUrl = pgwApiUrl;
    this.appClient = appClient;
    this.type = "observable";
    this.setType(type);
  }
  setHttpModel() {
    this.fetchModel = Fetcher;
  }
  get(url, params, entityName, headers) {
    if (url.startsWith("/")) {
      url = url.substr(1);
    }
    const request = this.fetchModel.get(
      `${this.apiUrl}/${url}`,
      params || null,
      entityName,
      headers
    );
    if (this.type === "observable") {
      return request.pipe(
        catchError((err) => this.errorHandler(err, this.type))
      );
    }
    return request.catch((err) => this.errorHandler(err, this.type));
  }
  post(url, params, entityName, headers) {
    if (url.startsWith("/")) {
      url = url.substr(1);
    }
    const request = this.fetchModel.post(
      `${this.apiUrl}/${url}`,
      params,
      null,
      headers
    );
    if (this.type === "observable") {
      return request.pipe(
        catchError((err) => this.errorHandler(err, this.type))
      );
    }
    return request.catch((err) => this.errorHandler(err, this.type));
  }
  /**
   *  REMOVE AFTER disabled auth basic
   * @param url
   * @param params
   * @param entityName
   * @param headers
   */
  getBlank(url, params, entityName, headers) {
    if (url.startsWith("/")) {
      url = url.substr(1);
    }
    const request = this.fetchModel.getBlank(
      `${this.apiUrl}/${url}`,
      params || null,
      entityName,
      headers
    );
    if (this.type === "observable") {
      return request.pipe(
        catchError((err) => this.errorHandler(err, this.type))
      );
    }
    return request.catch((err) => this.errorHandler(err, this.type));
  }
  /**
   *  REMOVE AFTER disabled auth basic
   * @param url
   * @param params
   * @param entityName
   * @param headers
   */
  postBlank(url, params, entityName, headers) {
    if (url.startsWith("/")) {
      url = url.substr(1);
    }
    const request = this.fetchModel.postBlank(
      `${this.apiUrl}/${url}`,
      params,
      null,
      headers
    );
    if (this.type === "observable") {
      return request.pipe(
        catchError((err) => this.errorHandler(err, this.type))
      );
    }
    return request.catch((err) => this.errorHandler(err, this.type));
  }
  put(url, params, entityName, headers) {
    if (url.startsWith("/")) {
      url = url.substr(1);
    }
    const request = this.fetchModel.put(
      `${this.apiUrl}/${url}`,
      params,
      null,
      headers
    );
    if (this.type === "observable") {
      return request.pipe(
        catchError((err) => this.errorHandler(err, this.type))
      );
    }
    return request.catch((err) => this.errorHandler(err, this.type));
  }
  patch(url, params, entityName, headers) {
    if (url.startsWith("/")) {
      url = url.substr(1);
    }
    const request = this.fetchModel.patch(
      `${this.apiUrl}/${url}`,
      params,
      null,
      headers
    );
    if (this.type === "observable") {
      return request.pipe(
        catchError((err) => this.errorHandler(err, this.type))
      );
    }
    return request.catch((err) => this.errorHandler(err, this.type));
  }
  delete(url, params, entityName, headers) {
    if (url.startsWith("/")) {
      url = url.substr(1);
    }
    const request = this.fetchModel.delete(
      `${this.apiUrl}/${url}`,
      params,
      null,
      headers
    );
    if (this.type === "observable") {
      return request.pipe(
        catchError((err) => this.errorHandler(err, this.type))
      );
    }
    return request.catch((err) => this.errorHandler(err, this.type));
  }
  setType(type) {
    this.type = type;
    this.setHttpModel();
  }
  getCookieLanguageInformation() {
    const spa = isSpa();
    const preferredLanguageCookie = getCookie(CookieTypes.preferredLanguageSPA);
    if (preferredLanguageCookie && spa) {
      return getCookie(CookieTypes.preferredLanguageSPA);
    }
    return null;
  }
}
export {
  ApiUrlTypes,
  ClientSwitcher,
  CustomerResponseTypes,
  preferredLanguageName
};
